import React, { useEffect, useState } from "react";
import { Button, Card, ListGroup } from "react-bootstrap";
import styled from "styled-components";
import { useUser } from "./UserContext";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import apiClient from "../Login/apiClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-regular-svg-icons";
import { faCalendarCheck } from "@fortawesome/free-regular-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import AdminNotices from "../../components/AdminNotices";
// import Router
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column; // これにより、子要素の表示が縦に並ぶ
  justify-content: center;
  align-items: center;
  height: auto;
  padding: 50px; // コンテナ内の余白
  background-color: #f5f5f5;

  margin: 20px;

  @media (max-width: 768px) {
    padding: 10px; // コンテナ内の余白
  }
`;

const StyledImage = styled.img`
  width: 20%;
  height: 15%;
  // margin-bottom: 20px; // 画像の下に余白を追加

  @media (max-width: 768px) {
    width: 30%;
  }
`;

const StyledCard = styled(Card)`
  width: 100%;
  margin-bottom: 10px; // カードの下に余白を追加
`;

const StyledCardHeader = styled(Card.Header)`
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 10px; // カードの下に余白を追加
`;

const StyledListGroup = styled(ListGroup)`
  width: 100%;
  margin-right: 400px;
  .list-group-item {
    padding: 10px 20px; // パディングを調整してコンテンツの配置を整える
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StyledCardHeaderID = styled(Card.Header)`
  font-size: 20px;
`;

const StyledLogoutButton = styled(Button)`
  width: 50%;
  margin-bottom: 20px; // ボタンの下に余白を追加
  &:hover {
    background-color: #333333;
  }

  @media (max-width: 768px) {
    width: 50%;
  }
`;

const StyledDeleteButton = styled(Button)`
  border: none;
  outline: none;
  width: 50%;
  margin-bottom: 20px; // ボタンの下に余白を追加
  &:hover {
    background-color: #333333;
  }

  @media (max-width: 768px) {
    width: 50%;
  }
`;

const ActionDeleteButton = styled(Button)`
  width: 120px; // 固定幅（お好みで調整可能）
  padding: 10px 16px;
  // margin-left: 50px;
  margin-bottom: 5px;
  border: 1px solid black;
  border-radius: 999px;
  font-family: "Segoe UI", "Noto Sans JP", "Helvetica Neue", sans-serif;
  font-size: 1.2rem;
  font-weight: 600;
`;

const ActionReviseButton = styled(Button)`
  width: 120px; // 固定幅（お好みで調整可能）
  padding: 10px 16px;
  // margin-left: 50px;
  margin-bottom: 5px;
  border: 1px solid black;
  border-radius: 999px;
  font-family: "Segoe UI", "Noto Sans JP", "Helvetica Neue", sans-serif;
  font-size: 1.2rem;
  font-weight: 600;
`;

const StyledLink = styled(Link)`
  font-size: 18px;
  font-weight: bold;
  font-family: "Segoe UI", "Noto Sans JP", "Helvetica Neue", sans-serif;
  // &:hover {
  //   color: white;
  //   text-decoration: none;
  // }
`;

const StyledCardHeaderTitle = styled.div`
  align-self: flex-start; /* 左寄せ */
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  font-family: "Segoe UI", "Noto Sans JP", "Helvetica Neue", sans-serif;
  border-bottom: 2px solid #2c3e50; /* 下線を追加 */
  padding-bottom: 4px;
  margin-bottom: 15px;
`;

const InfoBlock = styled.div`
  display: flex;
  align-items: center; /* アイコンとテキストを縦方向に中央揃え */
  gap: 10px; /* 各要素の間に余白 */
  border-radius: 8px;
  padding: 5px;
  background-color: #fafafa;
`;

const PostingGuideCard = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #fff4dd 0%, #fffdf6 100%);
  border: 1px solid #f1d8a8;
  border-radius: 18px;
  padding: 18px 18px 16px;
  margin: 12px 0 18px;
  box-shadow: 0 8px 24px rgba(80, 58, 18, 0.08);
`;

const PostingGuideTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 800;
  color: #4c3511;
  margin-bottom: 6px;
`;

const PostingGuideText = styled.p`
  margin: 0 0 14px;
  color: #5d4a28;
  line-height: 1.7;
  font-size: 0.96rem;
`;

const PostingGuideButton = styled(Button)`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 46px;
  padding: 12px 18px;
  border-radius: 999px;
  font-weight: 700;
  background-color: #282c34;
  border-color: transparent;
  color: #ffffff !important;
  text-decoration: none !important;
  overflow: hidden;

  &:hover,
  &:focus,
  &:active {
    background-color: #1f2329 !important;
    border-color: transparent !important;
    color: #ffffff !important;
    text-decoration: none !important;
  }
`;

const Label = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: #555;
`;

const Value = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: #555;
`;

const MyPage = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate(); //ページ遷移を制御するためにuseNavigateフックを使用する

  const { user, setUser, setIsLoggedIn } = useUser(); // ここで修正: useUserフックからuserを直接取得

  const [goals, setGoals] = useState([]);
  const [supportedGoals, setSupportedGoals] = useState([]);
  const [inquiries, setInquiries] = useState([]);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
    }
  }, [location.state]);

  // useEffect(() => {
  //   const fetchGoals = async () => {
  //     try {
  //       // アクセストークンの有効期限を確認し、期限切れの場合はリフレッシュ
  //       if (isTokenExpired(getAccessToken())) {
  //         const newToken = await refreshToken();
  //         if (!newToken) {
  //           return;
  //         }
  //       }
  //       const response = await apiClient.get(`${API_BASE_URL}/api/accounts/my-goals/`);
  //       setGoals(response.data);
  //     } catch (error) {
  //       console.error("Failed to fetch goals:", error);
  //     }
  //   };
  //   fetchGoals();
  // }, [API_BASE_URL, navigate]);

  const StyledListGroupItem = styled(ListGroup.Item)`
    display: flex;
    justify-content: center; // 名前中央寄せ
    align-items: center;
    font-size: 24px; // スマホでも見やすいサイズ感
    font-weight: 600; // 少し太め
    color: #2c3e50; // 落ち着いた濃いグレー
    font-family: "Segoe UI", "Noto Sans JP", "Helvetica Neue", sans-serif;
    letter-spacing: 0.5px;

    @media (max-width: 768px) {
      font-size: 30px;
    }
  `;

  // const StyledListGroupItem_Dream = styled(ListGroup.Item)`
  //   display: flex;
  //   align-items: center;
  //   color: #333;
  //   position: relative; /* ボタンの absolute 配置を適用するため */
  //   padding-right: 100px; /* ボタンのための余白を確保 */
  // `;

  const handleEdit = (goal) => {
    console.log(goal);
    navigate("/EditGoalRegister", { state: { goal } });
  };

  const handleDelete = (goal) => {
    navigate("/DeleteGoalRegister", { state: { goal } });
  };

  const changePassword = () => {
    navigate("/ChangePassword");
  };

  const withdrawal = () => {
    navigate("/DeleteAccount");
  };

  const StyledListGroupItem_Dream = styled(ListGroup.Item)`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `;

  const ButtonContainer = styled.div`
    display: flex;
    gap: 10px; /* ボタン間の間隔 */
  `;

  const GoalCard = styled.div`
    background-color: #ffffff;
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 15px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  `;

  const GoalInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;

    // @media (min-width: 768px) {
    //   flex-direction: row;
    //   justify-content: space-between;
    //   align-items: center;
    // }
  `;

  const GoalTitle = styled.span`
    font-size: 1.1rem;
    font-weight: bold;
    color: #333;
  `;

  const GoalDeadline = styled.span`
    font-size: 0.95rem;
    color: #666;
  `;

  const GoalActions = styled.div`
    display: flex;
    margin-top: 10px;
    justify-content: flex-end; /* ← 右寄せにする */
    gap: 6px;

    @media (min-width: 768px) {
      margin-left: 20px;
    }

    button {
      border-radius: 6px;
      padding: 6px 14px;
      font-size: 0.9rem;
      transition: all 0.2s ease-in-out;
    }

    button:hover {
      transform: scale(1.05);
    }
  `;

  // ログアウト処理
  const logout = () => {
    // localStorageからトークンを削除してログアウト状態にする
    // localStorage.removeItem("tokens");
    // localStorage.removeItem("ResponseData");
    // localStorage.removeItem("user");
    localStorage.clear();
    setUser(null);
    setIsLoggedIn(false);
    // ログアウト後にログイン画面に遷移する
    navigate("/login");
    window.location.reload(); // ★ 追加
  };

  useEffect(() => {
    const fetchGoals = async () => {
      try {
        const responce = await apiClient.get(`${API_BASE_URL}/api/accounts/my-goals/`);
        setGoals(responce.data);
        console.log(responce.data);
      } catch (error) {
        const errorCode = error?.response?.status;

        if (errorCode === 500) {
          toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
        } else {
          toast.error("予期せぬエラーが発生しました。");
        }
      }
    };
    fetchGoals();
  }, [API_BASE_URL, navigate]);

  useEffect(() => {
    const fetchSupportedGoals = async () => {
      try {
        const response = await apiClient.get(`${API_BASE_URL}/api/accounts/supported-goals/`);
        setSupportedGoals(response.data);
      } catch (error) {
        const errorCode = error?.response?.status;

        if (errorCode === 500) {
          toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
        } else {
          toast.error("予期せぬエラーが発生しました。");
        }
      }
    };

    fetchSupportedGoals();
  }, []);

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await apiClient.get(`${API_BASE_URL}/api/mypage/inquiries/`);
        setInquiries(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch inquiries:", error);
      }
    };

    fetchInquiries();
  }, [API_BASE_URL]);

  const categoryMap = {
    sports: "スポーツ",
    company: "会社",
    entrepreneurship: "起業",
    romance: "恋愛",
    self_satisfaction: "自己満足",
    literature: "漫画、文学",
  };

  const mappedCategory = (categoryEn) => {
    return categoryMap[categoryEn];
  }; // 英語を日本語に変換

  return (
    // <Container className="my-5">
    <Container>
      <StyledImage src="/img/MyPageIcon.png" />
      <StyledListGroupItem>{user.userID}</StyledListGroupItem>
      {false && <PostingGuideCard>
        <PostingGuideTitle>次は夢を1つ投稿してみよう</PostingGuideTitle>
        <PostingGuideText>
          投稿すると無謀度カードが作られて、掲示板でも反応がつきます。
          最初の1本は短くても大丈夫です。
        </PostingGuideText>
        <PostingGuideButton as={Link} to="/Register">
          夢を投稿する
        </PostingGuideButton>
      </PostingGuideCard>}
      <PostingGuideCard>
        <PostingGuideTitle>{goals.length === 0 ? "次は夢を1つ投稿してみよう" : "新しい夢も投稿してみよう"}</PostingGuideTitle>
        <PostingGuideText>
          {goals.length === 0
            ? "夢を投稿すると専用カードが作られて、掲示板での会話も始まります。まずは1本、気軽に叫んでみましょう。"
            : "次の夢を追加したり、別ルートの挑戦を書き足したりできます。思いついたうちに残しておくと流れがつきやすいです。"}
        </PostingGuideText>
        <PostingGuideButton as={Link} to="/Register">
          {goals.length === 0 ? "夢を投稿する" : "新しい夢を投稿する"}
        </PostingGuideButton>
      </PostingGuideCard>
      {/* <StyledCard>
        <StyledCardHeader>会員情報</StyledCardHeader>
        <StyledCardHeaderID>ユーザーID</StyledCardHeaderID>
        <StyledListGroup variant="flush">
          <StyledListGroupItem>{user.userID}</StyledListGroupItem>
        </StyledListGroup>
      </StyledCard> */}
      <StyledDeleteButton variant="primary" type="submit" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "50px", whiteSpace: "nowrap", fontSize: "1.0rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "transparent" }} onClick={() => changePassword()}>
        パスワードの変更
      </StyledDeleteButton>
      <AdminNotices title="運営からの連絡" />
      {/* <br /> */}
      {/* <StyledCard>
        <StyledCardHeader>無謀な夢リスト</StyledCardHeader>
        <ListGroup variant="flush">
          {goals.map((goal, index) => (
            <StyledListGroupItem_Dream key={index}>
              <strong> 【タイトル】</strong>
              <StyledLink to={`/boards/${goal.id}`}> {goal.title}</StyledLink>
              <br />
              <strong> 【目標実現日】</strong> {goal.deadline}
              <div>
                <ActionReviseButton block className="w-50 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "30px", whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", backgroundColor: "#282c34", borderColor: "transparent" }} onClick={() => handleEdit(goal)}>
                  修正
                </ActionReviseButton>
                <ActionDeleteButton variant="danger" block className="w-50 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "30px", whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent" }} onClick={() => handleDelete(goal)}>
                  削除
                </ActionDeleteButton>
              </div>
            </StyledListGroupItem_Dream>
          ))}{" "}
        </ListGroup>
      </StyledCard> */}
      <br />
      <StyledCardHeaderTitle>無謀な夢リスト</StyledCardHeaderTitle>
      <StyledCard>
        {/* <StyledCardHeader>無謀な夢リスト</StyledCardHeader> */}
        <div>
          {goals.map((goal, index) => (
            <GoalCard key={index}>
              <GoalInfo>
                <InfoBlock>
                  <Value>
                    <StyledLink to={`/boards/${goal.id}`}>{goal.title}</StyledLink>
                  </Value>
                </InfoBlock>

                <InfoBlock>
                  <FontAwesomeIcon icon={faCalendarCheck} size="2x" /> <Label>目標実現日:</Label>
                  <Value>{goal.deadline}</Value>
                </InfoBlock>
                <InfoBlock>
                  <FontAwesomeIcon icon={faClipboard} size="2x" /> <Label>カテゴリ:</Label>
                  <Value>{mappedCategory(`${goal.category}`)}</Value>
                </InfoBlock>
              </GoalInfo>
              <GoalActions>
                <ActionReviseButton variant="primary" block style={{ whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent", backgroundColor: "#282c34" }} onClick={() => handleEdit(goal)}>
                  修正
                </ActionReviseButton>
                <ActionDeleteButton variant="danger" block style={{ whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent" }} onClick={() => handleDelete(goal)}>
                  削除
                </ActionDeleteButton>
              </GoalActions>
            </GoalCard>
            // <GoalCard key={index}>
            //   <GoalInfo>
            //     <div>
            //       <GoalTitle>【タイトル】</GoalTitle>
            //       <GoalTitle>
            //         <StyledLink to={`/boards/${goal.id}`}>{goal.title}</StyledLink>
            //       </GoalTitle>
            //       <GoalDeadline>【目標実現日】{goal.deadline}</GoalDeadline>
            //     </div>
            //     <GoalActions>
            //       <ActionReviseButton onClick={() => handleEdit(goal)} style={{ backgroundColor: "#282c34", color: "#fff" }}>
            //         修正
            //       </ActionReviseButton>
            //       <ActionDeleteButton onClick={() => handleDelete(goal)} style={{ backgroundColor: "#dc3545", color: "#fff" }}>
            //         削除
            //       </ActionDeleteButton>
            //     </GoalActions>
            //   </GoalInfo>
            // </GoalCard>
          ))}
        </div>
      </StyledCard>

      <StyledCardHeaderTitle>運営への問い合わせ</StyledCardHeaderTitle>
      <StyledCard>
        <div style={{ padding: "12px" }}>
          <Button
            as={Link}
            to="/Contact"
            style={{
              display: "inline-flex",
              width: "auto",
              minWidth: "180px",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 18px",
              borderRadius: "999px",
              backgroundColor: "#282c34",
              borderColor: "transparent",
              color: "#ffffff",
              WebkitTextFillColor: "#ffffff",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "0.95rem",
              marginBottom: "12px",
            }}
          >
            運営に問い合わせる
          </Button>
          {inquiries.length === 0 ? (
            <div style={{ color: "#666", fontSize: "14px" }}>
              まだ問い合わせはありません。
            </div>
          ) : (
            inquiries.map((inquiry) => (
              <GoalCard key={inquiry.id}>
                <GoalInfo>
                  <InfoBlock>
                    <Label>{inquiry.category_label}</Label>
                    <Value>{inquiry.status_label}</Value>
                  </InfoBlock>
                  {inquiry.goal_title && (
                    <InfoBlock>
                      <Label>関連する夢</Label>
                      <Value>{inquiry.goal_title}</Value>
                    </InfoBlock>
                  )}
                  <div style={{
                    background: "#fafafa",
                    borderRadius: "8px",
                    padding: "10px",
                    whiteSpace: "pre-wrap",
                    color: "#444",
                  }}>
                    {inquiry.message}
                  </div>
                  {inquiry.admin_reply ? (
                    <div style={{
                      background: "#fff7db",
                      border: "1px solid #f0d37a",
                      borderRadius: "8px",
                      padding: "10px",
                      whiteSpace: "pre-wrap",
                      color: "#624700",
                    }}>
                      <strong>運営からの返信</strong>
                      <div style={{ marginTop: "6px" }}>{inquiry.admin_reply}</div>
                    </div>
                  ) : (
                    <div style={{ color: "#777", fontSize: "13px" }}>
                      返信待ちです。
                    </div>
                  )}
                </GoalInfo>
              </GoalCard>
            ))
          )}
        </div>
      </StyledCard>

      <StyledCardHeaderTitle>応援している夢リスト</StyledCardHeaderTitle>
      <StyledCard>
        <ListGroup variant="flush">
          {supportedGoals.map((goal, index) => (
            <GoalCard key={index}>
              <GoalInfo>
                <InfoBlock>
                  <Value>
                    <StyledLink to={`/boards/${goal.goal.id}`}>{goal.goal.title}</StyledLink>
                  </Value>
                </InfoBlock>
                <InfoBlock>
                  <FontAwesomeIcon icon={faUser} size="2x" /> <Label>作成者:</Label>
                  <Value>{goal.goal.user.username}</Value>
                </InfoBlock>
                <InfoBlock>
                  <FontAwesomeIcon icon={faCalendarCheck} size="2x" /> <Label>目標実現日:</Label>
                  <Value>{goal.goal.deadline}</Value>
                </InfoBlock>
                <InfoBlock>
                  <FontAwesomeIcon icon={faClipboard} size="2x" /> <Label>カテゴリ:</Label>
                  <Value>{mappedCategory(`${goal.goal.category}`)}</Value>
                </InfoBlock>
              </GoalInfo>
              <GoalActions>
                {/* <ActionReviseButton variant="primary" block style={{ whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent", backgroundColor: "#282c34" }} onClick={() => handleEdit(goal)}>
                  修正
                </ActionReviseButton> */}
                {/* <ActionDeleteButton variant="danger" block style={{ whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent" }} onClick={() => handleDelete(goal)}>
                  削除
                </ActionDeleteButton> */}
              </GoalActions>
            </GoalCard>

            // <StyledListGroupItem_Dream key={index}>
            //   <strong> 【タイトル】</strong>
            //   <StyledLink to={`/boards/${goal.goal.id}`}> {goal.goal.title}</StyledLink>
            //   <br />
            //   <strong> 【目標実現日】</strong> {goal.goal.deadline}
            //   <div>
            //     <ActionDeleteButton variant="danger" block className="w-50 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "30px", whiteSpace: "nowrap", fontSize: "1.1rem", color: "#ffffff", borderColor: "transparent" }} onClick={() => handleDelete(goal)}>
            //       削除
            //     </ActionDeleteButton>
            //   </div>
            // </StyledListGroupItem_Dream>
          ))}{" "}
        </ListGroup>
      </StyledCard>
      {/* <StyledLogoutButton variant="primary" type="submit" onClick={() => supportedGoals()}>
        応援している無謀な夢リスト
      </StyledLogoutButton> */}
      <br />
      <br />
      <StyledLogoutButton variant="primary" type="submit" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", backgroundColor: "#282c34", borderColor: "transparent" }} onClick={() => logout()}>
        ログアウト
      </StyledLogoutButton>
      <StyledDeleteButton variant="danger" type="submit" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent" }} onClick={() => withdrawal()}>
        退会
      </StyledDeleteButton>
      <ToastContainer position="top-center" autoClose={3000} />
    </Container>
  );
};

export default MyPage;

